'use strict';

/**
 * image and video functionality
 * @param {Object} $thumbnail - thumbnail
 * @param {Object} $playPause - playPause
 * @param {Object} $vidcontrols  - video controls
 */
function showPlayingState($thumbnail, $playPause, $vidcontrols) {
    $thumbnail.hide();
    $playPause.addClass('vidplay').removeClass('vidpause');
    $vidcontrols.show();
}

/**
 * @param {Object} $playPause - playPause
 */
function showPausedState($playPause) {
    $playPause.removeClass('vidplay vidpause');
}

/**
 * @param {Object} $video - video
 * @param {Object} videoElement - video Element
 */
function updateVideoSource($video, videoElement) {
    if (videoElement._videoSourceLoaded) { // eslint-disable-line
        return;
    }

    const $source = $video.find('source.mobile');
    const $sourceDesktop = $video.find('source.desktop');
    const dataSrc = $source.data('src');
    const dataSrcDesktop = $sourceDesktop.data('src');

    if (dataSrc || dataSrcDesktop) {
        if (dataSrc) {
            $source.attr('src', dataSrc);
        }
        if (dataSrcDesktop) {
            $sourceDesktop.attr('src', dataSrcDesktop);
        }

        videoElement._videoSourceLoaded = true; // eslint-disable-line
        const currentTime = videoElement.currentTime || 0; // eslint-disable-line
        videoElement.load();

        if (currentTime) {
            videoElement.currentTime = currentTime; // eslint-disable-line
        }

        videoElement.play().catch(() => {});
    }
}

/**
 * @param {Object} videoElement - videoElement
 * @param {Object} updateSource - updateSource
 */
function initLazyLoading(videoElement, updateSource) {
    if (videoElement.intersectionObserver) {
        videoElement.intersectionObserver.disconnect();
    }

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                updateSource();
            }
        }
    }, {
        threshold: 0.05
    });

    videoElement.intersectionObserver = observer; // eslint-disable-line
    observer.observe(videoElement);
}

/**
 * imageVideo
 */
export function imageVideo() {
    const $wrappers = $('.videoimg-wrapper');
    if (!$wrappers.length) {
        return;
    }

    $wrappers.each(function () {
        const $wrapper = $(this);

        if ($wrapper.data('video-init')) {
            return;
        }

        const $video = $wrapper.find('#video');
        const videoElement = $video[0];
        const $thumbnail = $wrapper.find('#thumbnail');
        const $playPause = $wrapper.find('#playPause');
        const $vidcontrols = $wrapper.find('.controls');

        if (!$video.length || !videoElement || !$playPause.length) {
            return;
        }

        const playVideo = () => showPlayingState($thumbnail, $playPause, $vidcontrols);
        const pauseVideo = () => showPausedState($playPause);
        const loadVideoSource = () => updateVideoSource($video, videoElement);

        $video.on('canplay', function () {
            this.play()
                .then(playVideo)
                .catch(() => {});
        });

        $playPause.on('click', function () {
            if (videoElement.paused) {
                videoElement.play();
                playVideo();
            } else {
                videoElement.pause();
                pauseVideo();
            }
        });

        $video.on('ended', pauseVideo);

        initLazyLoading(videoElement, loadVideoSource);

        $wrapper.data('video-init', true);
    });

    const $style = $('.banner-component').data('style');
    if ($style && $('link[href="' + $style + '"]').length === 0) {
        $('<link>', {
            rel: 'stylesheet',
            type: 'text/css',
            href: $style
        }).appendTo('head');
    }
}

$(document).ready(function () {
    imageVideo();
    $(document).on('search:filterChange recommendation:update', function () {
        imageVideo();
    });
    $(globalThis).on('resize', function () {
        imageVideo();
    });
});

export default {
    imageVideo
};
